import css from 'styled-jsx/css';

export default css`
  :global(.description-container h1) {
    font-size: 10px !important;
  }
  :global(.description-container span) {
    background-color: transparent !important;
  }
  :global(.description-container h2) {
    font-size: 10px !important;
    margin-bottom: 10px !important;
    margin-top: 10px !important;
  }
  :global(.description-container) {
    color: #9d9fad !important;
    margin-top: 40px;
  }
  :global(.description-container ul) {
    list-style: inside;
  }
`;
